import { createSelector } from '@reduxjs/toolkit';
import {
  FETCH_GET_BALANCE_REQUEST,
  FETCH_GET_BALANCE_SUCCESS,
  FETCH_GET_BALANCE_FAILURE,
  SET_BALANCE,
} from '../../types/user';

import { getApiSingleDetails, formatMoney } from '../../../modules/utils';

const GetBalanceReducer = (
  state = {
    data: null,
    error: null,
    isLoading: false,
  },
  action
) => {
  switch (action.type) {
    case FETCH_GET_BALANCE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_GET_BALANCE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.data.data,
        error: null,
      };
    case FETCH_GET_BALANCE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case SET_BALANCE:
      return {
        ...state,
        isLoading: false,
        data: { responseData: action.amount },
        error: null,
      };
    default:
      return state;
  }
};

export default GetBalanceReducer;

export const selectBalance = (state) => getApiSingleDetails(state.getBalance.data)?.balance;

export const selectFormattedBalance = createSelector([selectBalance], (balance) =>
  formatMoney(balance || '0', 'USD')
);
